import React from 'react'

export const WorkProcess = () => {
    return (
        <div>
<div class="container padding">
	<div class="welcome text-center">
		<div class="col-12">
			<h2>Our Working Process</h2>
		</div>
	</div>
	
</div>

 <section class="pt-120 pb-70 section-pattern">
        <div class="container">
            
            <div class="row process-bg w-process-image mb-4">
                <div class="col-lg-3 col-sm-6 single-process-wrapper">
                   
                    <div class="single-process text-center">
                      
                        <div class="process-image">
                            <img src={'./img/step-1.png'} data-rjs="2" alt="" />
                        </div>
                       

                     
                        <div class="content">
                            <h5>Research & Analyze</h5>
                          
                        </div>
                 
                    </div>
                 
                </div>
                <div class="col-lg-3 col-sm-6 single-process-wrapper">
                    
                    <div class="single-process text-center">
                       
                        <div class="process-image">
                            <img src={'./img/step-2.png'} data-rjs="2" alt="" />
                        </div>
                     

                       
                        <div class="content">
                            <h5>Planning</h5>
                            
                        </div>
                       
                    </div>
                 
                </div>
                <div class="col-lg-3 col-sm-6 single-process-wrapper">
                 
                    <div class="single-process text-center">
                     
                        <div class="process-image">
                            <img src={'./img/step-3.png'} data-rjs="2" alt="" />
                        </div>
                    

                    
                        <div class="content">
                            <h5>Execution & Launch</h5>
                            
                        </div>
                  
                    </div>
                  
                </div>
                <div class="col-lg-3 col-sm-6 single-process-wrapper">
                
                    <div class="single-process text-center">
                  
                        <div class="process-image">
                            <img src={'./img/step-4.png'} data-rjs="2" alt="" />
                        </div>
                   

                  
                        <div class="content">
                            <h5>Final Test</h5>
                          
                        </div>
                     
                    </div>
                 
                </div>
            </div>
        </div>
    </section>

</div>
    )
}

export default WorkProcess